const fetchAvCountries = (context, axios) => new Promise((resolve, reject) => {

    axios.post('api/user/countries/available')
        .then((response) => {
            resolve(response)
        })
        .catch((error) => {
            reject(error)
        })
})

export default {
    fetchAvCountries
};
